import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Capture PWA install prompt event ASAP (it fires only once per page load)
if (typeof window !== "undefined") {
    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        window.__alliedDeferredBIP = e;
        window.dispatchEvent(new Event("allied-bip-ready"));
    });
    window.addEventListener("appinstalled", () => {
        window.__alliedDeferredBIP = null;
        try {
            const raw = localStorage.getItem("allied_pod_install_prompt");
            const prev = raw ? JSON.parse(raw) : {};
            localStorage.setItem(
                "allied_pod_install_prompt",
                JSON.stringify({ ...prev, installed: true }),
            );
        } catch {
            /* ignore */
        }
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
